<div class="credit-info-container flex flex-column gap-3 mb-5" [formGroup]="termsAndConditionsForm">
  <div>
    <span class="title">
      <app-translate key="TERMS_AND_CONDITIONS"></app-translate>
    </span>
  </div>
  <div>
    <span class="sub-title">
      <app-translate key="PURCHASE_REQUIRES_ACCEPTANCE"></app-translate>
    </span>
  </div>
  <p-divider></p-divider>
  <div class="border-round">
    @for (term of allTerms; track term) {
      <div class="mb-4">
        <div>
          <div class="flex mb-2">
            <span class="font-semibold text-xl">{{ term.consentLabel }}</span>
          </div>
          <!-- Show link if termUrl exists -->
          @if (term.termUrl) {
            <div class="sub-title mb-3">
              <a [href]="term.termUrl" target="_blank"
                (click)="onConsumerAgreementClick(term.termText, term.termUrl, term.id); $event.preventDefault()"
                class="color-sara-blue">
                <app-translate key="CLICK_READ_TERMS"></app-translate>
              </a>
            </div>
          }
          <!-- Show inline HTML only if no termUrl -->
          @if (term.termHtml && !term.termUrl) {
            <div class="sub-title mb-3">
              <span [innerHTML]="term.termHtml" class="sub-title"></span>
            </div>
          }
          <div class="sub-title">
            <div class="checkbox-span">
              <p-checkbox [inputId]="term.id" [formControlName]="'term_' + term.id"
                (onChange)="onConsumerAgreementChecked(term.id, $event)" [binary]="true" />
              <label [for]="term.id" class="ml-2 sub-title">
                @if (term.consentHtml) {
                  <span class="consent-html-wrapper"
                  [innerHTML]="getSafeHtml(term.consentHtml)"></span>
                }
                @if (!term.consentHtml) {
                  <span>{{ term.consentText }}</span>
                }
              </label>
            </div>
            <sp-control-error [control]="termsAndConditionsForm.controls['term_' + term.id]"
              [messagesParameters]="[{ key: 'required', message: languageService.getTranslation('FIELD_MUST_BE_CONFIRMED') }]">
            </sp-control-error>
          </div>
        </div>
      </div>
      <p-divider></p-divider>
    }
  </div>
  <div>
    @if (signatureRequired && termsAndConditionsForm.controls['signType']) {
      <div>
        <div class="title text-base">
          <app-translate key="ELECTRONIC_SIGNATURE"></app-translate>
        </div>
        <div class="sub-title mb-3">
          <app-translate key="ESIGN_DISCLOSURE"></app-translate>
        </div>
        <div class="col-12">
          <div class="flex flex-column">
            <label htmlFor="name" class="form-label required">
              <app-translate key="ENTER_FIRST_LAST_NAME"></app-translate>:
            </label>
            <div>
              <input type="text" placeholder="" pInputText formControlName="signType" (change)="onNameChange()"
                class="w-full input-margin" />
            </div>
            <sp-control-error [control]="termsAndConditionsForm.controls['signType']"
            [messagesParameters]="[{key : 'required', message : languageService.getTranslation('FIELD_MUST_BE_CONFIRMED')}]"></sp-control-error>
          </div>
        </div>
        <div class="sub-title mb-3 mt-3">
          <app-translate key="DIGITAL_SIGNATURE_ACKNOWLEDGEMENT"></app-translate>
        </div>
      </div>
    }
    <div>
      @if (formRequiredValidationShow()) {
        <div class="error-message mb-2">
          <app-translate key="MISSING_SELECTIONS"></app-translate>
        </div>
      }
      <div class="mb-3">
        <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onFormSubmit()"
          styleClass="p-button-lg w-full p-button-primary" />
      </div>
      <div class="mb-3">
        <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
          (onClick)="onFormCancel()" />
      </div>
    </div>
    <div>
      <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
    </div>
  </div>
</div>

<p-dialog [header]="languageService.getTranslation('ARE_YOU_SURE')" [modal]="true" [(visible)]="externalLinkPopup"
  [breakpoints]="{ '5550px': '80vw','575px': '90vw' }" styleClass="border-round-3xl">
  <div class="flex flex-column gap-3">
    <span class="sub-title">
      <app-translate key="EXTERNAL_LINK_WARNING"></app-translate>
    </span>
    <div class="flex flex-1 gap-3 justify-content-end">
      <p-button [label]="languageService.getTranslation('CANCEL')" [outlined]="true" styleClass="button"
        (click)="onExternalPopupLinkClick(false)" />
      <p-button [label]="languageService.getTranslation('YES')" styleClass="button"
        (click)="onExternalPopupLinkClick(true)" />
    </div>
  </div>
</p-dialog>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancelConfimation($event)"></app-confirm-popup>

<p-dialog [header]="languageService.getTranslation('TERMS_AND_CONDITIONS')" [modal]="true"
  [(visible)]="isConsumerAgreementVisible" [breakpoints]="{ '5550px': '80vw','575px': '90vw' }"
  styleClass="border-round-3xl">
  <div class="flex flex-column gap-3">
    <span (click)="handleLinkClick($event);" (keyup)="handleLinkClick($event);" [innerHTML]="termsText"
      class="sub-title" tabindex="0">
    </span>
    <div class="flex flex-1 gap-3 justify-content-end">
      <p-button [label]="languageService.getTranslation('CANCEL')" [outlined]="true" styleClass="button"
        (click)="onPopupCancel()" />
      <p-button [label]="languageService.getTranslation('AGREE_TO_TERMS')" styleClass="button"
        (click)="onPopupSubmit()" />
    </div>
  </div>
</p-dialog>

<p-dialog [header]="languageService.getTranslation('COMPLETE_REQUIRED_FIELDS')" [modal]="true"
  [(visible)]="isRequiredConfirmVisible" [breakpoints]="{ '5550px': '80vw','575px': '90vw' }"
  styleClass="border-round-3xl">
  <div class="flex flex-column gap-3">
    <span [innerHTML]="languageService.getTranslation('REQUIRED_FIELDS_MESSAGE')" class="sub-title" tabindex="0">
    </span>
    <div class="flex flex-1 gap-3 justify-content-end">
      <p-button [label]="languageService.getTranslation('OKAY')" styleClass="button"
        (click)="onRequiredFieldSubmit()" />
    </div>
  </div>
</p-dialog>